import React, { useState } from "react";
import styled from "styled-components";
import { Button } from "antd";

const Trending = styled.div`
  padding-top: 7rem;
  padding-left: 8rem;
  padding-right: 8rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const SmallHeader = styled.h2`
  text-align: left;
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  line-height: 100%;
`;

const CitiesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const CityCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const CityImage = styled.div`
  border-radius: 16px;
  height: 250px;
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 100%);
  }
`;

const CityName = styled.h3`
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  color: white;
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
`;

const CityDescription = styled.p`
  color: #666;
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const ViewMoreButton = styled(Button)`
  background: #1890ff;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0 24px;
  height: 40px;
  font-weight: 500;
  align-self: flex-end;
  margin-top: 2rem;

  &:hover {
    background: #40a9ff;
    color: white;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;
`;

// Sample data for trending cities
const trendingCities = [
  {
    name: "Lagos",
    description:
      "Nigeria's largest city and economic hub, known for its vibrant nightlife, beaches, and business opportunities.",
    image: "https://images.unsplash.com/photo-1574786577759-aebe09a843c6",
  },
  {
    name: "Abuja",
    description: "Nigeria's capital city with beautiful architecture, parks, and government buildings.",
    image: "https://images.unsplash.com/photo-1506929562872-bb421503ef21",
  },
  {
    name: "Port Harcourt",
    description: "Oil-rich city in the Niger Delta region with a mix of urban development and natural beauty.",
    image: "https://images.unsplash.com/photo-1583258292688-d0213dc5a3a8",
  },
  {
    name: "Kano",
    description: "Ancient city with rich history and culture, known for its traditional crafts and commerce.",
    image: "https://images.unsplash.com/photo-1518621736915-f3b1c41bfd00",
  },
  {
    name: "Calabar",
    description: "Coastal city famous for its carnival, wildlife, and beautiful colonial architecture.",
    image: "https://images.unsplash.com/photo-1506929562872-bb421503ef21",
  },
  {
    name: "Enugu",
    description: "Picturesque city surrounded by hills, known for its cool climate and coal mining history.",
    image: "https://images.unsplash.com/photo-1503917988258-f87a78e3c995",
  },
  {
    name: "Ibadan",
    description: "One of Africa's largest cities by land area, with a rich academic and cultural scene.",
    image: "https://images.unsplash.com/photo-1506197603052-3cc9c3a201bd",
  },
  {
    name: "Uyo",
    description: "Fast-growing city with modern infrastructure and access to beautiful natural attractions.",
    image: "https://images.unsplash.com/photo-1506260408121-e353d10b87c7",
  },
  {
    name: "Abeokuta",
    description: "Historic city known for its rock formations and as the birthplace of many Nigerian icons.",
    image: "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4",
  },
];

const TrendingCitiesSection: React.FC = () => {
  const [visibleCities, setVisibleCities] = useState(6); // Show 6 cities initially (2 rows)

  const loadMore = () => {
    setVisibleCities(prev => prev + 3); // Add 3 more cities (1 more row)
  };

  return (
    <Trending>
      <SmallHeader>Trending Cities to visit</SmallHeader>
      <CitiesContainer>
        {trendingCities.slice(0, visibleCities).map((city, index) => (
          <CityCard key={index}>
            <CityImage style={{ backgroundImage: `url(${city.image})` }}>
              <CityName>{city.name}</CityName>
            </CityImage>
            <CityDescription>{city.description}</CityDescription>
          </CityCard>
        ))}
      </CitiesContainer>
      {visibleCities < trendingCities.length && (
        <ButtonContainer>
          <ViewMoreButton onClick={loadMore}>See More Cities</ViewMoreButton>
        </ButtonContainer>
      )}
    </Trending>
  );
};

export default TrendingCitiesSection;
